import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
import { LoaderPopConfig, LoaderPopService } from './loader-pop.service';

@Component({
  selector: 'app-loader-pop',
  templateUrl: './loader-pop.component.html',
  styleUrls: ['./loader-pop.component.scss']
})
export class LoaderPopComponent implements OnInit {
  pendingActionsCount: number = 0;
  @ViewChild("loader") showLoader: ModalDirective | undefined;
  constructor(private loaderPopService: LoaderPopService) { 
    console.log("test loader");
    
    // this.showLoader.show()
    this.loaderPopService.notifySubject.subscribe((data: any) => {
      this.notifyLoader(data);
    });
  }

  ngOnInit(): void {
    // this.showLoader?.show()
  }

  notifyLoader(config: LoaderPopConfig) {
    if (this.pendingActionsCount === 0) {
      this.showLoader?.show()
    }
    if (config.createAction) {
      this.pendingActionsCount++;
    // the extra check for > 0, to avoid getting into a situation where pendingActionsCount goes into negative.
    } else if (this.pendingActionsCount > 0) {
      this.pendingActionsCount--;
    }
    if (this.pendingActionsCount === 0) {
      this.showLoader?.hide();
    }
  }
}
